import {
  isLiaisonOfficerRole,
  isProofReaderRole,
} from '@/core/features/shared/helpers/user-role.helper'
import { ENV_TOKEN } from '@/core/features/shared/services/app.injector'
import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { MeFacade } from '../../me/services/me.facade'

export const canActivateUsersDashboard: CanActivateFn = () => {
  const meFacade = inject(MeFacade)
  const router = inject(Router)
  const environment = inject(ENV_TOKEN)

  const me = meFacade.me

  if (!me) {
    const returnUrl = `${window.location.origin}/${environment.appName}`
    window.location.href = `${environment.apiUrl}/saml/login?returnUrl=${returnUrl}`
    return false
  }

  if (me && meFacade.isUserAllowed('codices')) {
    if (isLiaisonOfficerRole(me.authorities)) {
      router.navigate(['/user/liaison-agent'])
      return false
    }
    if (isProofReaderRole(me.authorities)) {
      router.navigate(['/user/proofreader'])
      return false
    }
  }

  meFacade.redirectCodices(true)
  return false
}
